{
  "translation": {
    "activities": {
      "transport_detail": {
        "call_driver": "Gọi tài xế",
        "need_support": "Bạn cần hỗ trợ?",
        "no_trip": "Bạn chưa có chuyến đi nào",
        "phone": {
          "description": "Bạn có muốn gọi tới số",
          "title": "Hỗ trợ qua điện thoại"
        },
        "title": "Chi tiết chuyến đi",
        "cancelled_trip_reason_title": "Chuyến đi chưa được thực hiện",
        "cancelled_trip_reason_description": "Bạn có thể đặt lại để tiếp tục chuyến đi",
        "rebook": "Đặt lại",
        "book_return": "Đặt quay về"
      }
    },
    "auth": {
      "complete_register": {
        "done": "Xong",
        "email_description": "Nhập email để tăng cường bảo mật.",
        "full_name": "Họ và tên",
        "referral_code": "Mã giới thiệu",
        "referral_code_description": " Nhập mã của bạn bè để cả hai nhận phần thường.",
        "title": "Hoàn tất đăng ký"
      },
      "login": {
        "confirmation": "Bằng việc tiếp tục, bạn đồng ý với <1>Quy chế sàn TMDT</1>, <3>Quy chế bảo vệ dữ liệu cá nhân</3> và <5>Hợp đồng vận chuyển</5> của be.",
        "or_login_with": "Hoặc đăng nhập bằng",
        "subtitle": "Đăng nhập/Đăng ký tài khoản <0>be</0> ngay bây giờ",
        "title": "Lên xe cùng be"
      },
      "otp": {
        "description": "Mã xác thực sẽ được gửi đến <1>{{phoneNumber}}</1>. Bạn vui lòng kiểm tra tin nhắn và nhập mã xác thực vào đây.",
        "resend_otp": "Gửi lại mã xác thực",
        "resend_otp_in": "Gửi lại mã xác thực ({{time}})",
        "title": "Nhập mã OTP"
      },
      "password": {
        "description": "Bạn đang đăng nhập với số điện thoại",
        "error": "Mật khẩu không đúng",
        "forgot_password": "Quên mật khẩu",
        "title": "Nhập mật khẩu"
      },
      "placeholder": {
        "phone_number": "Số điện thoại của bạn"
      },
      "session": {
        "expired_message": "Không thể xác minh người dùng. Vui lòng đăng nhập lại."
      },
      "validation": {
        "email": "Phải là địa chỉ email hợp lệ.",
        "phone_number": "Bạn ơi, vui lòng nhập đúng số điện thoại.",
        "required": "Vui lòng điền vào trường này."
      }
    },
    "be": "be",
    "common": {
      "add": "Thêm",
      "app_name": "be",
      "around": "Khoảng",
      "back": "Quay lại",
      "call": "Gọi",
      "cancel": "Huỷ",
      "cancelled": "Đã hủy",
      "completed": "Đã hoàn thành",
      "cash": "Tiền mặt",
      "close": "Đóng",
      "collapse": "Thu nhỏ",
      "confirm": "Xác nhận",
      "continue": "Tiếp tục",
      "delete": "Xóa",
      "done": "Xong",
      "exit": "Thoát",
      "food_checkout_title": "Checkout",
      "got_it": "Đã hiểu",
      "hide": "Ẩn",
      "i_got_it": "Tôi đã hiểu",
      "language": {
        "en": "English",
        "vi": "Tiếng Việt"
      },
      "loading": "Đang tải",
      "login_with": "Đăng nhập với",
      "non_supported": {
        "description": "Dịch vụ này chưa được hỗ trợ trên phiên bản hiện tại. Vui lòng dùng ứng dụng be để sử dụng.",
        "payment": "Liên kết phương thức thanh toán này chưa được hỗ trợ trên phiên bản hiện tại. Vui lòng dùng ứng dụng be để sử dụng.",
        "title": "Không khả dụng"
      },
      "non_supported_session": {
        "description": "Bạn không thể xem chuyến xe này ở phiên bản hiện tại. Vui lòng dùng ứng dụng be để sử dụng.",
        "title": "Thông tin chuyến đi"
      },
      "ok": "OK",
      "password": "mật khẩu",
      "payment": "Thanh toán",
      "reply": "Trả lời",
      "required": "Bắt buộc",
      "reselect": "Chọn lại",
      "ride_contract": "Hợp đồng vận chuyển",
      "save": "Lưu",
      "scroll_to_top": "Lên đầu trang",
      "see_less": "Ẩn bớt",
      "see_more": "Xem thêm",
      "send": "Gửi",
      "show": "Hiện",
      "support": "Hỗ trợ",
      "term_and_condition": "Điều kiện & Điều khoản",
      "time": {
        "hour": "giờ",
        "min": "phút"
      },
      "try_again": "Thử lại",
      "use": "Sử dụng",
      "version": "Phiên bản",
      "view_all": "Xem tất cả"
    },
    "food_action_agree": "Đồng ý",
    "food_action_create_new_order": "Đặt đơn mới",
    "food_action_create_new_order_with_no": "Không, đặt đơn khác",
    "food_action_keep_order": "Giữ lại món",
    "food_action_rate": "Đánh giá",
    "food_cancel_order_title": "Lý do huỷ đơn",
    "food_cart_additem_title": "Thêm vào giỏ",
    "food_cart_empty_desc": "Hãy để <1>be</1> lắp đầy chiếc bụng đói của bạn!",
    "food_cart_empty_modal_message": "Bạn vui lòng quay lại trang của quán để cập nhật thêm giỏ hàng nhé",
    "food_cart_empty_modal_title": "Giỏ hàng rỗng",
    "food_cart_empty_title": "Giỏ hàng hiện đang trống",
    "food_cart_explore_now": "Khám phá ngay",
    "food_cart_title": "Giỏ hàng của tôi",
    "food_cart_updateitem_title": "Cập nhật giỏ hàng",
    "food_change_location": "Đổi địa điểm",
    "food_checkout_action_add_item": "Thêm món",
    "food_checkout_action_order": "Đặt món",
    "food_checkout_deliver_to": "Giao tới",
    "food_checkout_error_content": "Rất tiếc, mã khuyến mãi bạn đang chọn không thể áp dụng. Bạn muốn bỏ chọn mã khuyến mãi không hợp lệ trước khi thanh toán hay chọn lại mã khuyến mãi mới?",
    "food_checkout_error_title": "Mã khuyến mãi không hợp lệ",
    "food_checkout_fee_delivery": "Phí giao hàng",
    "food_checkout_fee_doorstep": "Phí giao tận cừa",
    "food_checkout_fee_insurance": "Bảo hiểm đơn hàng",
    "food_checkout_fee_parking": "Phí gửi xe",
    "food_checkout_fee_process": "Phí xử lý đơn hàng",
    "food_checkout_fee_small_order": "Phí đơn hàng nhỏ",
    "food_checkout_fee_total": "Phí áp dụng",
    "food_checkout_note": "Ghi chú",
    "food_checkout_note_input_title": "Ghi chú",
    "food_checkout_order": "Đơn hàng",
    "food_checkout_order_cancel": "Huỷ",
    "food_checkout_order_item": "món",
    "food_checkout_order_sending": "Đơn hàng đang được gửi đi...",
    "food_checkout_paid_by": "Trả qua",
    "food_checkout_promotion": "Khuyến mại",
    "food_checkout_promotion_action_apply": "Áp dụng",
    "food_checkout_promotion_selected": "Đã chọn {{amount}} ưu đãi",
    "food_checkout_promotion_skip": "Bỏ qua mã ưu đãi và tiếp tục",
    "food_checkout_temporary_price": "Tạm tính",
    "food_checkout_title": "Thanh toán",
    "food_checkout_toll_fee": "Phụ phí",
    "food_checkout_total_price": "Tổng số tiền",
    "food_common_item_like_one": "thích",
    "food_common_item_like_other": "thích",
    "food_common_item_sold_one": "đã bán",
    "food_common_item_sold_other": "đã bán",
    "food_common_pieces": "phần",
    "food_editaddress_title": "Nơi nhận",
    "food_estimated_delivery_time": "Dự kiến giao hàng",
    "food_finish_title": "Cảm ơn bạn đã chọn Be",
    "food_home_deliveryto_title": "Giao tới",
    "food_home_goodrestonearby_title": "Quán ngon gần bạn",
    "food_home_location_determining": "Đang xác định vị trí...",
    "food_home_search_placeholder": "Tìm món ăn hoặc nhà hàng",
    "food_intrip_action_view_route": "Xem lộ trình",
    "food_intrip_order_cancelled": "Đơn hàng đã bị huỷ",
    "food_intrip_order_detail": "Chi tiết đơn hàng",
    "food_not_support_location": "Hiện tại be chưa có mặt tại khu vực của bạn. Vui lòng chọn địa chỉ mới hoặc thử lại sau nhé.",
    "food_order_action_cancel": "Huỷ đơn",
    "food_order_action_cancel_order": "Huỷ đơn hàng",
    "food_order_action_cannot_cancel_detail": "Tại sao tôi không thể huỷ đơn hàng",
    "food_order_cannot_cancel_title": "Món ăn đang được nhà hàng chuẩn bị, vì vậy bạn không thể hủy đơn này. Vui lòng chờ trong giây lát bạn nhé.",
    "food_order_cart_action_delete_all": "Xoá hết",
    "food_order_cart_action_view_order": "Xem đơn hàng",
    "food_order_cart_note_for_resto": "Ghi chú cho quán",
    "food_order_cart_title": "Giỏ hàng",
    "food_order_delivered": "Đã giao",
    "food_order_desc_waiting_for_confirmation_desc": "sẽ gửi thông tin đơn hàng đến bạn khi nhà hàng đã xác nhận",
    "food_order_desc_waiting_for_confirmation_title": "Bạn chờ nhà hàng chút nhé",
    "food_order_desc_waiting_for_driver": "sẽ gửi thông tin đơn hàng đến bạn khi tìm thấy tài xế phù hợp",
    "food_order_detail": "Chi tiết đơn hàng",
    "food_order_detail_distance": "Quãng đường",
    "food_order_id": "Mã đơn hàng",
    "food_order_not_delivered": "Chưa giao",
    "food_order_quantity_edit_title": "Nhập số lượng",
    "food_order_view_detail_button": "Xem chi tiết đơn hàng",
    "food_promo_input_placeholder": "Nhập mã khuyến mại",
    "food_promo_input_submit": "Thêm mã",
    "food_promo_merchant_applied_max": "Bạn có thể sử dụng tối đa {{count}} lần",
    "food_promo_merchant_applied_resto": "Quán áp dụng",
    "food_promo_merchant_description": "Thông tin khác",
    "food_promo_merchant_discount_amount": "Áp dụng khuyến mãi {{amount}} tối đa {{upto}}",
    "food_promo_merchant_discount_amount_without_percent": "Áp dụng khuyến mãi {{amount}}",
    "food_promo_merchant_max_order_value": "Giá trị đơn hàng tối đa được áp dụng khuyến mãi",
    "food_promo_merchant_min_order_value": "Giá trị đơn hàng tối thiểu để áp dụng khuyến mãi",
    "food_promo_merchant_payment_method": "Hình thức thanh toán",
    "food_promo_not_applicable": "Không đủ điều kiện sử dụng",
    "food_promo_not_eligible": "Mã khuyến mãi không đủ điều kiện áp dụng",
    "food_promo_view_more": "Xem thêm {{amount}} ưu đãi khác",
    "food_rating_driver_desc": "Bạn đánh giá tài xế của bạn như thế nào?",
    "food_rating_driver_input_placeholder": "Chia sẻ cảm nhận của bạn",
    "food_rating_driver_title": "Đánh giá tài xế",
    "food_rating_order_detail_title": "Chi tiết đơn hàng",
    "food_rating_restaurant_desc": "Bạn đánh giá các món tại {{restaurantName}} như thế nào?",
    "food_rating_restaurant_title": "Đánh giá nhà hàng",
    "food_rating_resto_item_title": "Món ăn có hợp khẩu vị với bạn?",
    "food_rating_resto_title": "Đánh giá món ăn và nhà hàng",
    "food_restaurant_lists": "Danh sách tất cả cửa hàng",
    "food_resto_cart_action_delete_cart_message": "Bạn có chắc muốn xoá hết các món đang có trong giỏ hàng không?",
    "food_resto_cart_action_delete_cart_title": "Xoá giỏ hàng",
    "food_resto_detail_open_at": "Mở cửa vào {{time}} ngày {{date}}",
    "food_resto_detail_review": "đánh giá",
    "food_resto_item_choose_limit_max": "Chọn tối đa {{num}}",
    "food_resto_item_choose_limit_min": "Chọn tối thiểu {{num}}",
    "food_resto_item_no_reviews": "Chưa có đánh giá",
    "food_resto_item_not_available": "Hết món",
    "food_resto_item_note_placeholder": "Cho quán biết thêm về yêu cầu của bạn.",
    "food_resto_item_note_title": "Ghi chú cho quán",
    "food_resto_minimum_order_value": "Trị giá đơn hàng tối thiểu",
    "food_resto_new_restaurant": "Quán mới",
    "food_resto_open_at": "Mở cửa vào",
    "food_resto_required_message": "Bạn vui lòng chọn các mục bắt buộc",
    "food_resto_search_no_result_message": "Hãy thử đổi từ khoá hoặc tìm quán khác nhé",
    "food_resto_search_no_result_title": "Không tìm thấy kết quả phù hợp",
    "food_resto_search_placeholder": "Tìm món tại",
    "food_resto_view_all_store": "Xem tất cả {{count}} cửa hàng",
    "food_search_before_desc": "Cảm thấy đói bụng? Tìm kiếm món ăn để đặt đơn thôi bạn ơi",
    "food_search_before_title": "Món ngon đang chờ bạn tìm kiếm",
    "home": {
      "activities": {
        "subtitle": "Hoạt động",
        "tabs": {
          "delivery": "Giao hàng",
          "food": "Ăn uống",
          "transport": "Đặt xe"
        },
        "title": "Hoạt động"
      },
      "input_dropoff": "Bạn muốn be đưa đến nơi nào?",
      "input_dropoff_loading": "Đang xác định...",
      "other_services": "Dịch vụ khác",
      "request_location": {
        "actions": {
          "allow": "Cho phép sử dụng định vị",
          "edit_location": "Chọn địa điểm"
        },
        "declined": "Be cần địa chỉ của bạn để có thể hoạt động, bạn sẽ được chuyển đến trang cập nhật địa chỉ thủ công.",
        "description": "Để có thể tối ưu chọn điểm đến, điểm đón cũng như các dịch vụ khác của Be, vui lòng cho chúng tôi biết địa điểm của bạn!",
        "error": "Có lỗi xảy ra khi lấy vị trí của bạn, bạn sẽ được chuyển đến trang cập nhật thủ công."
      },
      "rewards": {
        "subtitle": "Đổi ưu đãi",
        "title": "Ưu đãi"
      },
      "welcome": "Chào, {{name}}"
    },
    "location_add_home": "Thêm nhà",
    "location_add_other": "Thêm địa điểm",
    "location_add_work": "Thêm công ty",
    "location_home": "Nhà",
    "location_work": "Công ty",
    "login_password_wrong_attempts_message": "Mật khẩu không đúng, bạn còn {{remain}} lần thử lại.",
    "payment_methods": {
      "title": "Hình thức thanh toán"
    },
    "payment_try_another_method": "Đổi phương thức thanh toán",

    "promotions": {
      "coupons": {
        "actions": {
          "use_later": "Dùng sau",
          "use_now": "Dùng ngay"
        },
        "expired_at": "Sử dụng đến"
      },
      "detail": {
        "title": "Chi tiết khuyến mại"
      },
      "input_placeholder": "Nhập mã ưu đãi",
      "title": "Ưu đãi"
    },
    "require_permission_location_description": "be cần thông tin vị trí để có thể gợi ý các dịch vụ có hỗ trợ tại khu vực của bạn.",
    "require_permission_location_title": "be cần vị trí của bạn",
    "require_permission_phonenumber_description": "Số điện thoại của bạn sẽ được dùng để định danh và nhận thông báo từ be.",
    "require_permission_phonenumber_no_permission": "be cần quyền truy cập số điện thoại để có thể đăng nhập với Zalo",
    "require_permission_phonenumber_title": "be cần thông tin của bạn",
    "ride": {
      "cancel_trip": {
        "form": {
          "other": {
            "title": "Vui lòng nêu rõ lý do"
          }
        },
        "reasons": {
          "title": "Lý do huỷ chuyến"
        },
        "submit": "Huỷ chuyến"
      },
      "chat": {
        "input": {
          "placeholder": "Aa"
        },
        "message": {
          "sent": "Đã gửi"
        }
      },
      "common": {
        "book_long_ride": "Đặt",
        "book_ride": "Đặt",
        "drop_off": "Điểm đến",
        "pick_from_map": "Chọn từ bản đồ",
        "pick_up": "Điểm đón",
        "saved_locations": "Địa điểm đã lưu",
        "suggested_addresses": "Địa điểm được đề xuất",
        "user_location": "Chọn địa điểm"
      },
      "confirm_address": {
        "actions": {
          "confirm": "Xác nhận điểm đón"
        },
        "placeholder": {
          "note": "Ghi chú cho tài xế"
        }
      },
      "contract": {
        "address": "Địa chỉ cư trú",
        "be": "Công ty cổ phần BE GROUP",
        "birth_year": "Năm sinh",
        "customer_information": "Thông tin người thuê vận tải",
        "customer_name": "Họ và tên",
        "description": "Điều khoản cụ thể của hợp đồng vận chuyển hành khách",
        "distance": "Cự ly",
        "driver_information": "Thông tin tài xế",
        "driver_name": "Họ và tên",
        "dropoff_location": "Điểm kết thúc",
        "end_time": "Thời gian kết thúc",
        "license_plate_number": "Biển kiểm soát",
        "number_of_seats": "Số chỗ",
        "passenger_information": "Thông tin hành khách",
        "passenger_name": "Họ và tên",
        "passenger_one": "hành khách",
        "passenger_other": "hành khách",
        "payment": "Giá cước chuyến đi",
        "phone_number": "Số điện thoại",
        "pickup_location": "Điểm bắt đầu",
        "start_time": "Thời gian bắt đầu",
        "tax_number": "Mã số thuế (nếu có)",
        "title": "Hợp đồng vận chuyển",
        "trip_information": "Thông tin hành trình",
        "vehicle_information": "Thông tin phương tiện"
      },
      "fare": {
        "error": {
          "cannot_use_promo_code": {
            "title": "Đặt xe không khuyến mại"
          },
          "trip_radius_too_short": {
            "description": "Chuyến đi của bạn quá ngắn, vui lòng chọn một điểm đến xa hơn."
          }
        },
        "option": {
          "form": {
            "invoice": {
              "company_address": {
                "label": "Địa chỉ công ty",
                "placeholder": "Nhập địa chỉ công ty",
                "validation": "Địa chỉ công ty không được để trống"
              },
              "company_name": {
                "label": "Tên công ty",
                "placeholder": "Nhập tên công ty",
                "validation": "Tên công ty không được để trống"
              },
              "description": "Chỉ áp dụng khi thanh toán bằng Tiền mặt và Thẻ",
              "email": {
                "label": "Email",
                "placeholder": "Nhập email",
                "validation": "Email không hợp lệ"
              },
              "label": "Xuất hoá đơn",
              "success": "Cập nhật thông tin xuất hoá đơn thành công",
              "tax_code": {
                "label": "Mã số thuế",
                "placeholder": "Nhập mã số thuế",
                "validation": "Mã số thuế không hợp lệ"
              },
              "title": "Tôi cần xuất hoá đơn"
            },
            "note": {
              "label": "Ghi chú cho tài xế",
              "placeholder": "Nhập ghi chú"
            },
            "validation": {
              "email": "Phải là địa chỉ email hợp lệ.",
              "required": "Vui lòng điền vào trường này.",
              "tax_code": "Mã số thuế không hợp lệ."
            }
          },
          "invoice": {
            "title": "Thông tin xuất hoá đơn"
          },
          "title": "Tuỳ chọn"
        }
      },
      "in_trip": {
        "actions": {
          "cancel": "Huỷ chuyến",
          "cancel_booking": "Huỷ chuyến",
          "normal_call": "Gọi thường",
          "text": "Nhắn tin"
        },
        "info": {
          "cost": "Cước phí",
          "distance": "Cự ly",
          "drop_off_another": "Đang trả khách",
          "engagement_id": "Mã chuyến đi",
          "fare": "Cước phí",
          "insurance": "Bảo hiểm",
          "paid_by": "Trả qua",
          "paid_in": "Trả qua",
          "payment": "Thanh toán",
          "promotion": "Khuyến mại",
          "time": "Di chuyển",
          "tip": "Tip cho tài xế",
          "addi": "Phụ phí",
          "total_amount": "Tổng cộng",
          "trip_detail": "Chi tiết chuyến đi",
          "waiting_time": "Thời gian chờ",
          "with_invoice": "Có hoá đơn"
        },
        "status": {
          "finding_driver": "Đang tìm tài xế...",
          "no_drivers_description": "Bạn vui lòng thử lại sau nhé",
          "no_drivers_title": "Tất cả tài xế đều đang bận"
        }
      },
      "rate_driver": {
        "description": "Bạn đánh giá tài xế của bạn thế nào ?",
        "feedback_placeholder": "Chia sẻ cảm nhận của bạn",
        "subtitle": "Đánh giá tài xế",
        "thank_you": "Cảm ơn bạn đã tham gia đánh giá tài xế.",
        "title": "Cảm ơn bạn đã chọn be"
      },
      "select_address": {
        "placeholder": {
          "current_address": "Nhập địa chỉ hiện tại",
          "drop_off": "Nhập điểm đến",
          "pick_up": "Nhập điểm đón",
          "recipient": "Nơi nhận",
          "save_location": "Nhập địa điểm"
        }
      },
      "trip_status": {
        "accepted": "Tài xế của bạn đang đến",
        "arrived": "Tài xế đã đến",
        "cancelled_by_driver": "Lý do huỷ: Tài xế đã hủy chuyến",
        "finding_driver": "Đang tìm tài xế...",
        "order_cancelled": "Đơn hàng của bạn đã bị huỷ",
        "perfect_ride": "Tài xế đang trả khách và sẽ đến",
        "started": "Đang trong chuyến"
      }
    },
    "ride_confirmaddress_notefordriver_input_title": "Ghi chú cho tài xế",
    "ride_promotion_other_promo_title": "Tất cả ưu đãi",
    "ride_promotion_user_promo_title": "Ưu đãi bạn nên dùng trước",
    "ride_save_address_form_field_address_label": "Địa điểm",
    "ride_save_address_form_field_name_label": "Tên địa điểm",
    "ride_save_address_form_field_name_placeholder": "Nhập tên địa điểm",
    "ride_save_address_form_title": "Xác nhận địa chỉ",
    "session_expired_description": "Vui lòng đăng nhập lại.",
    "session_expired_title": "Phiên đăng nhập hết hạn",
    "session_not_found_title": "Chuyến đi đã hoàn thành hoặc không tồn tại.",
    "transport_having_another_trip_cta_1": "Xem chi tiết",
    "transport_having_another_trip_cta_2": "Quay về trang chủ",
    "transport_having_another_trip_desc": "Chuyến đi đến {{addr}} của bạn chưa hoàn tất, bạn có muốn xem chi tiết chuyến đi này?",
    "transport_having_another_trip_title": "Đang có chuyến đi khác",
    "transport_rating_engagement_detail_title": "Chi tiết chuyến đi",
    "user": {
      "settings": {
        "logout": "Đăng xuất",
        "payment": "Thanh toán",
        "promotion": "Khuyến mại",
        "select_language": "Chọn ngôn ngữ",
        "title": "Cài đặt"
      }
    },
    "user_support_cta_phone": "Hỗ trợ qua điện thoại",
    "user_support_title": "Hỗ trợ",
    "chat_no_message": "Chưa có tin nhắn nào",
    "verification_title": "Nhập mã xác thực",
    "verification_desc": "Vui lòng nhập mã xác thực được gửi đến số điện thoại <1>{{phoneNumber}}</1> để tiếp tục.",
    "resend_otp": "Gửi lại mã xác thực",
    "resend_otp_in": "Gửi lại mã xác thực ({{countdown}})",
    "unexpected_error": "Có lỗi xảy ra, vui lòng thử lại sau.",
    "verification_sending_otp": "Đang gửi mã xác thực...",
    "verification_retrying_otp": "Đang thử lại ({{attempt}}/{{max}})...",
    "verification_send_failed_title": "Không thể gửi mã xác thực",
    "verification_send_failed_desc": "Chúng tôi chưa thể gửi mã xác thực đến số điện thoại của bạn. Vui lòng kiểm tra kết nối mạng và thử lại.",
    "verification_send_failed_support": "Nếu vẫn gặp sự cố, vui lòng liên hệ <1>hotline 1900232345</1> để được hỗ trợ.",
    "verification_try_again": "Thử lại",
    "verification_go_back": "Quay lại",
    "verification_resend_failed": "Không thể gửi lại mã. Vui lòng thử lại sau.",
    "wrong_otp": "Mã xác thực không chính xác. Vui lòng nhập lại",
    "ride_select_payment_method": "Chọn PTTT",
    "input_location": "Nhập vị trí",
    "common_next": "Tiếp tục",
    "unauthorized_title": "Rất tiếc, truy cập của bạn đã bị từ chối. Vui lòng thử lại sau.",
    "unauthorized_title_partner": "Phiên đăng nhập của bạn đã hết hạn. Vui lòng mở lại be từ ứng dụng {{partnerName}} để tiếp tục sử dụng.",
    "transport_book_now": "Đặt xe ngay",
    "detail": "Chi tiết",
    "transport_return_book": "Đặt quay về",
    "transport_rebook": "Đặt lại",
    "promo_use": "Sử dụng",
    "promo_deselect": "Bỏ chọn",
    "ride_finding_driver_title": "Đang tìm tài xế cho bạn",
    "ride_current_pickup": "Điểm đón hiện tại",
    "ride_payment_failed": "Thanh toán thất bại",
    "ride_payment_failed_desc_debt": "Bạn chưa thanh toán số tiền <1>{{amount}}</1> cho dịch vụ đã sử dụng. Vui lòng thanh toán qua ứng dụng be để tiếp tục sử dụng dịch vụ.",
    "add_payment_method_title": "Thêm phương thức thanh toán",
    "add_payment_method_not_available": "Thêm phương thức thanh toán này không khả dụng trên phiên bản hiện tại, vui lòng thực hiện trên ứng dụng be.",
    "permission_granted": "Đã cấp quyền",
    "permission_name_avatar": "Tên và ảnh đại diện",
    "permission_name_avatar_desc": "Được sử dụng để định danh và truy cập các tính năng từ Zalo (bắt buộc)",
    "permission_phone_number": "Số điện thoại",
    "permission_phone_number_desc": "Được sử dụng để định danh và liên lạc với tài xế.",
    "permission_open_settings": "Quản lý quyền truy cập",
    "permission_zalo_required": "Be cần truy cập vào tên và ảnh đại diện để có thể hoạt động",
    "tap_to_see_more": "Nhấn để xem thêm",
    "choose_from_map_title_pickup": "Chọn điểm đón",
    "choose_from_map_title_dropoff": "Chọn điểm đến",
    "choose_from_map_desc_pickup": "Xác nhận hoặc thay đổi điểm đón của bạn",
    "choose_from_map_desc_dropoff": "Xác nhận hoặc thay đổi điểm đến của bạn"
  }
}
